import { render, staticRenderFns } from "./BaseInputGroup.vue?vue&type=template&id=5f825b7a"
import script from "./BaseInputGroup.vue?vue&type=script&lang=ts"
export * from "./BaseInputGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports